<div class="col-md-12">
     <div class="panel download-panel">
        <div class="panel-body " >
            <div class="download-large-receipt" [style.display]="(resultContentObj!=undefined && resultContentObj.ResponseStatus==3 && messageId!=undefined) ? 'block' : 'none'"  >
                <h5 class="body-title">{{"DownloadLargeReceipt.BodyTitle" | translate}}</h5>
                <div class="row">
                    <div class="col-md-4"><span class="leftp">{{"DownloadLargeReceipt.SubjectLabel" | translate}} :</span></div>
                    <div class="col-md-8"><span class="rightp">{{resultContentObj.Subject}}</span></div>
                </div>
                <div class="row">
                    <div class="col-md-4"><span class="leftp">{{'DownloadLargeReceipt.ReceiptForLabel' | translate}} :</span></div>
                    <div class="col-md-8"><span class="rightp">{{resultContentObj.SenderAddress}}</span></div>
                </div>
                <div class="row">
                    <div class="col-md-4"><span class="leftp">{{"DownloadLargeReceipt.ReceiptDateLabel" | translate}} :</span></div>
                    <div class="col-md-8"><span class="rightp">{{resultContentObj.MessageDate}}</span></div>
                </div>
                <div class="row">
                    <div class="col-md-12"><br>
                        <button  (click)="DownloadLargeReceipt()" type="button" id="largeReceiptDownload" class="btn btn-success">
                            {{"DownloadLargeReceipt.DownloadButtonText" | translate}}</button>
                        </div>
                </div>
            </div>
            <div class="panel-body-error"  [style.display]="(resultContentObj!=undefined 
            && (resultContentObj.ResponseStatus==0 || resultContentObj.ResponseStatus==1 ||
            resultContentObj.ResponseStatus==2
             )) ? 'block' : 'none'" >
             <p class="texterror">{{resultContentObj.ResponseMessage}}</p>
            </div>
            <div class="panel-body-error"  [style.display]="messageId==undefined? 'block' : 'none'" >
                <p class="texterror">{{"DownloadLargeReceipt.InvalidMessageId" | translate }}</p>
            </div>   
        </div> 
        </div>
    </div> 
    
    <div id="divDownloading" class="download-Loader" style="display:none;"></div>


